import {
  createAsyncThunk,
  createSelector,
  createSlice,
} from "@reduxjs/toolkit";
import dayjs from "dayjs";

import { getScheduleReportApi } from "@/utils/apis/doctor/report";

import { RootState } from "@/store/store";

export const fetchScheduleReport = createAsyncThunk(
  "scheduleReport/fetch",
  async ({ startDate, endDate }: { startDate: string; endDate: string }) => {
    const adjustedEndDate = dayjs(endDate).add(1, "day").format("YYYY-MM-DD");
    const response = await getScheduleReportApi(startDate, adjustedEndDate);
    return response;
  }
);

const initialState = {
  data: null,
  status: "idle",
  error: null,
};

const scheduleReportSlice = createSlice({
  name: "scheduleReport",
  initialState,
  reducers: {
    resetReport: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchScheduleReport.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(fetchScheduleReport.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.data = action.payload;
      })
      .addCase(fetchScheduleReport.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload || "Failed to fetch report";
      });
  },
});

const selectScheduleReport = (state: RootState) => state.scheduleReport;

export const scheduleReportSelector = createSelector(
  [selectScheduleReport],
  (scheduleReport) => ({
    data: scheduleReport.data,
    status: scheduleReport.status,
    error: scheduleReport.error,
  })
);

export const { resetReport } = scheduleReportSlice.actions;

export default scheduleReportSlice.reducer;
